'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _pick = require('lodash/pick');

var _pick2 = _interopRequireDefault(_pick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  for (var _len = arguments.length, keys = Array(_len), _key = 0; _key < _len; _key++) {
    keys[_key] = arguments[_key];
  }

  return function (_ref) {
    var actions = _ref.actions,
        state = _ref.state;

    // If no keys were specified, just return the action and state
    if (keys.length === 0) return _extends({}, actions, { state: state });
    if (keys[0] === 'state') return { state: state };

    return _extends({}, (0, _pick2.default)(actions, keys), {
      state: state
    });
  };
};